const SvgIconTokenizedAlt = (props) => (
  <svg viewBox="0 0 104 91" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M52 91c28.719 0 52-8.586 52-19.178 0-10.591-23.281-19.177-52-19.177S0 61.23 0 71.822C0 82.414 23.281 91 52 91Z"
      fill="#29A964"
    />
    <path
      d="M52 39.107c28.719 0 52-8.754 52-19.553C104 8.754 80.719 0 52 0S0 8.754 0 19.554c0 10.799 23.281 19.553 52 19.553Z"
      fill="#F2D6BB"
    />
    <path
      d="M52 65.43c28.719 0 52-8.755 52-19.555 0-10.799-23.281-19.553-52-19.553S0 35.076 0 45.875c0 10.8 23.281 19.554 52 19.554Z"
      fill="#EFAC26"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M91.067 58.642c-9.571 4.098-23.647 6.687-39.34 6.687-15.693 0-29.769-2.589-39.34-6.686 9.571-4.098 23.647-6.687 39.34-6.687 15.693 0 29.769 2.589 39.34 6.686Z"
      fill="#2525D7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M91.067 32.972c-9.57 4.098-23.646 6.687-39.34 6.687-15.692 0-29.768-2.59-39.34-6.687 9.572-4.098 23.648-6.687 39.34-6.687 15.694 0 29.77 2.589 39.34 6.687Z"
      fill="#F06C22"
    />
  </svg>
);

export default SvgIconTokenizedAlt;
